import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Matter extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'Matter'
  // Define default properties here
    static instanceDefaults() {
    return {
      matter_id: '',
      name : {
          fr: '',
          de: '',
          en: ''
      },
    }
  }
}
const servicePath = 'matters'
const servicePlugin = makeServicePlugin({
    Model: Matter,
    service: feathersClient.service(servicePath),
    servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
